var React = require('react');

function PlatyIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.8","cx":"28.9435","cy":"29.7131","r":"28.6109","fill":"white","stroke":"white","strokeWidth":"0.6","key":0}),React.createElement("path",{"d":"M41.2134 30.1776C41.6801 30.447 41.6801 31.1206 41.2134 31.39L21.7272 42.6404C21.2605 42.9098 20.6772 42.573 20.6772 42.0342L20.6772 19.5334C20.6772 18.9945 21.2605 18.6578 21.7272 18.9272L41.2134 30.1776Z","fill":"#122436","stroke":"white","strokeWidth":"0.6","key":1})]);
}

PlatyIcon.defaultProps = {"width":"58","height":"59","viewBox":"0 0 58 59","fill":"none"};

module.exports = PlatyIcon;

PlatyIcon.default = PlatyIcon;
